import { Injectable } from '@angular/core';
import { ID } from '@datorama/akita';
import { PaymethodWizardStore } from './paymethod-wizard.store';
import {
    PaymethodWizard,
    paymethodWizardFactory,
} from './paymethod-wizard.model';
import { PaymethodWizardQuery } from './paymethod-wizard.query';

@Injectable({ providedIn: 'root' })
export class PaymethodWizardService {
    constructor(
        private paymethodWizardStore: PaymethodWizardStore,
        private paymethodWizardQuery: PaymethodWizardQuery
    ) {}

    add(paymethodWizard: PaymethodWizard) {
        this.paymethodWizardStore.add(paymethodWizard);
    }

    update(id, paymethodWizard: Partial<PaymethodWizard>) {
        this.paymethodWizardStore.update(id, paymethodWizard);
    }

    remove(id: ID) {
        this.paymethodWizardStore.remove(id);
    }

    setPaymethodsWizard(paymethodsWizard: PaymethodWizard[]) {
        this.paymethodWizardStore.set(paymethodsWizard);
    }

    setPaymethodChecked(paymethodWizardId, checked: boolean) {
        this.resetPaymethodChecked();
        this.paymethodWizardStore.update(paymethodWizardId, { checked });
    }

    togglePaymethodChecked(paymethodWizardId) {
        const checked = !this.paymethodWizardQuery.getEntity(paymethodWizardId)
            .checked;
        this.resetPaymethodChecked();
        this.paymethodWizardStore.update(paymethodWizardId, { checked });
    }

    resetPaymethodChecked() {
        this.paymethodWizardStore.update(({ checked }) => checked, {
            checked: false,
        });
    }

    /*------------*/
    /** SERVICIOS */
    /*------------*/

    /**
     * Crea los paymethods a partir de la información que llega de la API
     */
    setPaymethodsWizardByApi(paymethodsWizard) {
        if (paymethodsWizard) {
            const paymethodsWizardEntities = [];
            paymethodsWizard.forEach((paymethodWizard) => {
                paymethodsWizardEntities.push(
                    paymethodWizardFactory(paymethodWizard)
                );
            });

            this.setPaymethodsWizard(paymethodsWizardEntities);
        }
    }

    setActive(paymethodId: string) {
        this.paymethodWizardStore.setActive(paymethodId);
    }

    resetStore() {
        this.paymethodWizardStore.reset();
    }
}
